import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getActionLevels } from '../api/actionApi'

/**
 * Aksiyon editörü picklist seçenekleri — Aciliyet Derecesi + Önem Derecesi (REFERANS). Adlar sunucuda dile
 * göre çözülür → aktif dil ({@code i18n.language}) key'e girer ki dil değişince yeniden çekilsin.
 *
 * `enabled` — gizli monte edilen bir diyalog (ör. ana sayfadaki "Görev Oluştur") seçenekleri ancak
 * açılınca çekmeli: uç görev okuma yetkisi ister ve yetkisiz kullanıcıda diyalog hiç açılmasa da 403 +
 * "yetkiniz yok" uyarısı üretiyordu (Standart Kullanıcı, 17.10.2026).
 */
export function useActionLevels(enabled = true) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['action-levels', i18n.language],
    queryFn: getActionLevels,
    staleTime: 5 * 60 * 1000,
    enabled,
  })
}
